import { render } from "./App.vue?vue&type=template&id=0dbe3faa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0dbe3faa&lang=scss"
script.render = render

export default script